import type { Toast as ToastModel } from "../stores/toasts.ts";
import { Spinner } from "./Spinner.tsx";
import s from "./primitives.module.css";

const KIND_CLASS = {
  info: s.toastInfo,
  success: s.toastSuccess,
  error: s.toastError,
  pending: s.toastPending,
} as const;

export function Toast({
  toast,
  onDismiss,
}: { toast: ToastModel; onDismiss: (key: string) => void }) {
  return (
    // `alert` for an error (interrupts), `status` for everything else (announced at the next opportunity). A
    // pending trade toast that interrupted the user on every stage change would be unusable.
    <div
      className={[s.toast, KIND_CLASS[toast.kind]].join(" ")}
      role={toast.kind === "error" ? "alert" : "status"}
    >
      {toast.kind === "pending" ? <Spinner /> : null}
      <span>{toast.text}</span>
      {toast.href ? (
        <a href={toast.href} target="_blank" rel="noreferrer noopener">
          view
        </a>
      ) : null}
      <button
        type="button"
        className={s.toastDismiss}
        onClick={() => onDismiss(toast.key)}
        aria-label="Dismiss"
      >
        ✕
      </button>
    </div>
  );
}
